import hsFetch from 'hellospa/hs-fetch';

// This should match the type of whatever the BE sends, so I think it makes
// sense to define the type in the same file that fetches the data. -Asa
export type GroupSettings = {
  groups: string[]
}

const groupSettings = {
  async getGroupSettings(): Promise<GroupSettings> {
    // hsFetch handles the CSRF token for you
    const result = await hsFetch('/example');
    const data = await result.json();
    return data;
  },
};

export default groupSettings;

// These services will be used by Storybook and tests
function buildMocks(): typeof groupSettings {
  return {
    async getGroupSettings() {
      return {
        groups: ['admin', 'IT'],
      };
    },
  };
}

export const mockGroupSettings = (
  process.env.NODE_ENV === 'production'
    ? () => ({} as typeof groupSettings)
    : buildMocks
);
